/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_YouInputs */

const th_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ของคุณ`)
};

const en_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You`)
};

const ja_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自分`)
};

const zh_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的`)
};

const es_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tú`)
};

const pt_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você`)
};

const id_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda`)
};

const fr_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous`)
};

const tl_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikaw`)
};

const vi_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn`)
};

const ko_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 정보`)
};

const de_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du`)
};

const ru_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы`)
};

const tr_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siz`)
};

const it_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu`)
};

const pl_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ty`)
};

const uk_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви`)
};

const hi_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप`)
};

const ar_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنت`)
};

const ms_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda`)
};

const bn_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনি`)
};

const zh_tw2_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的`)
};

const zh_hk2_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的`)
};

const ur_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ`)
};

const fa_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شما`)
};

const sw_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wewe`)
};

const nl_nav_you = /** @type {(inputs: Nav_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jij`)
};

/**
* | output |
* | --- |
* | "You" |
*
* @param {Nav_YouInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const nav_you = /** @type {((inputs?: Nav_YouInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_YouInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_nav_you(inputs)
	if (locale === "ja") return ja_nav_you(inputs)
	if (locale === "zh") return zh_nav_you(inputs)
	if (locale === "es") return es_nav_you(inputs)
	if (locale === "pt") return pt_nav_you(inputs)
	if (locale === "id") return id_nav_you(inputs)
	if (locale === "fr") return fr_nav_you(inputs)
	if (locale === "tl") return tl_nav_you(inputs)
	if (locale === "vi") return vi_nav_you(inputs)
	if (locale === "ko") return ko_nav_you(inputs)
	if (locale === "de") return de_nav_you(inputs)
	if (locale === "ru") return ru_nav_you(inputs)
	if (locale === "tr") return tr_nav_you(inputs)
	if (locale === "it") return it_nav_you(inputs)
	if (locale === "pl") return pl_nav_you(inputs)
	if (locale === "uk") return uk_nav_you(inputs)
	if (locale === "hi") return hi_nav_you(inputs)
	if (locale === "ar") return ar_nav_you(inputs)
	if (locale === "ms") return ms_nav_you(inputs)
	if (locale === "bn") return bn_nav_you(inputs)
	if (locale === "zh-TW") return zh_tw2_nav_you(inputs)
	if (locale === "zh-HK") return zh_hk2_nav_you(inputs)
	if (locale === "ur") return ur_nav_you(inputs)
	if (locale === "fa") return fa_nav_you(inputs)
	if (locale === "sw") return sw_nav_you(inputs)
	if (locale === "nl") return nl_nav_you(inputs)
	return en_nav_you(inputs)
});